import { joe } from './../characters/Joe';
import { mc } from '@lss/common/game/characters/MC';
import ImageClass from "../../src/shell/Image";
import { vanessa } from '../characters/Vanessa';
import { images } from "./images";
import Question from '../../src/shell/Questions';
import { jump } from '../../src/shell/jump';
import { empty } from '../characters/empty';
import { AfterClubEndDay } from './V4';
import Game from '../../src/shell/Game';
import { endReplay } from '../../src/shell/endReplay';
import { replayScenesList } from '../../src/components/menu/Scenes/replayScenes/scenesReplayData';

export const AfterClubSexTape = async (): Promise<any> => {
    ImageClass.setImage(images.v4.SexTape0, { transition: true });
    mc.think(`Time to see what he wants.`);
    ImageClass.setImage(images.v4.SexTape1);

    vanessa.talk(`Hey ${mc.name}.`);
    if (Game.seenScenarios.includes(`beachVanessaAlone5`)) {

        mc.think(`I remember this outfit, she was wearing it the other day when I was here with her.`);
    } else {

        mc.think(`Woah.`);

    }
    mc.talk(`Did I come at a bad time?`);
    ImageClass.setImage(images.v4.SexTape2);
    joe.talk(`You came just in time!`);
    joe.talk(`Please, come inside.`);
    ImageClass.setImage(images.v4.SexTape3, { transition: true });
    if (Question.globalAnswers.v4ToldJoeyToTurnAround) {
        mc.talk(`I am glad to see you two made up.`);
        ImageClass.setImage(images.v4.SexTape4);
        joe.talk(`Yeah... We talked, and everything is fine now.`);
        vanessa.talk(`He can't be mad at me on his birthday!`);
    }
    mc.talk(`So... what is it?`);
    if (Question.globalAnswers.v4TrickJoeyDrinkDrug) {

        mc.think(`Joey looks wasted, I did trick him to drink Vanessa's special ingredient.`);
    }
    ImageClass.setImage(images.v4.SexTape3);
    joe.talk(`Vanessa and I were talking and Vanessa came up with an idea.`);
    joe.talk(`But she told me that you were the one who actually had the idea for a sex tape.`);
    mc.talk(`Yeah...`);
    joe.talk(`We started recording but it's so hard to hold the camera straight if you know what I mean.`);
    mc.talk(`I get you.`);
    joe.talk(`I'll just say it.`);
    joe.talk(`Will you be our cameraman?`);
    joe.talk(`I know it's not an ordinary request and it might be embarrassing for you but it's my birthday and I can't think of anyone better for this.`);
    mc.talk(`Is Vanessa ok with this?`);
    ImageClass.setImage(images.v4.SexTape4);
    joe.talk(`It was her idea.`);
    vanessa.talk(`That's right!`);
    ImageClass.setImage(images.v4.SexTape3);
    mc.talk(`Why am I not surprised?`);
    return jump(AfterClubSexTapeQuestion1, "AfterClubSexTapeQuestion1");
};

export const AfterClubSexTapeQuestion1 = async (): Promise<any> => {
    ImageClass.setImage(images.v4.SexTape3);
    await joe.setQuestion(new Question({ text: `So, what do you say?`, options: { think: false }, key: `v4SexTapeAgreeToFilm` })
        .option({ title: `Agree`, key: true })
        .option({ title: `Refuse`, key: false }));


    if (Question.globalAnswers.v4SexTapeAgreeToFilm) {

        mc.talk(`It's your birthday, how can I say no?`);
        joe.talk(`Thanks man!`);
        vanessa.talk(`${mc.name} is the best!`);
        return jump(AfterClubSexTapeAgree, "AfterClubSexTapeAgree");
    } else {
        mc.think(`Birthday or not I'm not going to watch Joey fuck Vanessa.`);
        mc.think(`He may think I'm a bad friend for not agreeing, but what am I supposed to do?`);
        mc.think(`Masturbate while they fuck? Hell no.`);
        mc.talk(`Sorry man, I know it's your birthday but it's too much for me.`);
        vanessa.talk(`Come on ${mc.name}, don't be a nerd!`);
        joe.talk(`I get it dude.`);
        joe.talk(`Sorry for not saying it over the phone, I just thought it would be easier to convince you once you are here.`);
        joe.talk(`Thanks anyway.`);
        mc.talk(`Cya guys.`);
        return jump(AfterClubSexTapeRefused, "AfterClubSexTapeRefused");
    }
};

export const AfterClubSexTapeAgree = async (): Promise<any> => {
    ImageClass.setImage(images.v4.SexTape3);
    mc.talk(`How are we going to do this?`);
    ImageClass.setImage(images.v4.SexTape5);
    joe.talk(`Take the camera.`);
    joe.talk(`Try to make us look good.`);
    joe.talk(`And I don't need to say this but focus mainly on Vanessa.`);
    joe.talk(`I'd rather see her on video than me.`);
    ImageClass.setImage(images.v4.SexTape6);

    vanessa.talk(`Finally.`);
    vanessa.talk(`Are you ready for me honey?`);
    joe.talk(`Always.`);
    mc.think(`Vanessa didn't hesitate.`);
    mc.think(`The moment I took the camera she jumped on Joey.`);
    ImageClass.setImage(images.v4.SexTape7);

    mc.think(`She pulled his underwear off and started stroking his dick.`);
    vanessa.talk(`${mc.name}, are you getting this?`);
    mc.talk(`Yes.`);
    mc.think(`I don't know if she had done this before but she looked like a natural.`);
    mc.think(`The fact that this might leak didn't bother her at all.`);
    joe.talk(`Ahh...`);
    mc.think(`Joey seems to like it.`);
    mc.talk(`Vanessa, you should undress.`);

    if (Question.globalAnswers.todMCDareVanessa === "showBoobs") {

        vanessa.talk(`I knew you've been dying to see my boobs again since yesterday.`);
    } else {

        vanessa.talk(`I knew you've been dying to see my pussy again since yesterday.`);
    }
    ImageClass.setImage(images.v4.SexTape8);

    mc.think(`Vanessa lifted her top and covered her nipples with her hands while staring at the camera.`);
    mc.think(`I know the sex tape was meant for Joey, but she was looking directly at me.`);
    ImageClass.setImage(images.v4.SexTape9, { duration: 1 });
    mc.think(`Without saying a word she removed her top and pulled down the bottom of her outfit.`);
    return jump(AfterClubSexTapeAgree2, "AfterClubSexTapeAgree2");
};
export const AfterClubSexTapeAgree2 = async (): Promise<any> => {
    ImageClass.setImage(images.v4.SexTape10);

    await vanessa.setQuestion(new Question({ text: `I hope you know what you are doing, I want to look good on cam.`, options: { think: false }, key: `v4SexTapeWhenFilmingVanessaMCSaid` })
        .option({ title: `You are`, key: `youAre` })
        .option({ title: `Don't worry`, key: `dontWorry` })
        .option({ title: `You always look good`, key: `youAlwaysLookGood` }));


    if (Question.globalAnswers.v4SexTapeWhenFilmingVanessaMCSaid === "youAre") {

        mc.talk(`You are looking good don't worry.`);
    } else if (Question.globalAnswers.v4SexTapeWhenFilmingVanessaMCSaid === "dontWorry") {

        mc.talk(`Don't worry, let me handle this.`);
    } else {
        await mc.set((properties) => {
            properties.vanessaRelationship++;
        });
        mc.talk(`You always looks good.`);
        vanessa.talk(`Ohh...`);
        mc.think(`Joey doesn't mind that I'm flirting with her.`);
        if (Question.globalAnswers.v4TrickJoeyDrinkDrug) {

            mc.think(`Maybe he is just too drunk to realize.`);
        }

    }

    vanessa.talk(`You are rude.`);
    mc.talk(`Me? Why?`);
    vanessa.talk(`You are the only one dressed.`);
    mc.talk(`I get the hint.`);
    ImageClass.setImage(images.v4.SexTape11, { transition: true });
    vanessa.talk(`Oh! You like what you see.`);
    mc.talk(`What did you expect?`);
    vanessa.talk(`Exactly that.`);
    ImageClass.setImage(images.v4.SexTape10);

    mc.think(`While Vanessa and I were talking Joey was keeping quiet... It was weird.`);
    mc.think(`He was usually the one who tried to stand out.`);
    vanessa.talk(`Let's keep this show going.`);
    ImageClass.setImage(images.v4.SexTape12, { transition: true });
    mc.think(`Vanessa started sucking Joey's dick.`);

    ImageClass.setAnimation(images.v4.AnimSexTape);
    // <action type="image" video="true" nb="true" wi="true" preload="Game/V4/AnimSexTape_Frame" loop="true">Game/V4/AnimSexTape</action>
    joe.talk(`Ohh... `);
    mc.think(`I usually see stuff like this on webcam videos over the internet, but now I'm in the front row.`);
    joe.talk(`Fuck honey, you suck soo good.`);
    joe.talk(`Damn!`);
    joe.talk(`You are so good at that, I'm going to cum if you keep going.`);
    vanessa.talk(`Mmmff mmmhhhnnn...`);
    joe.talk(`Stop and stay in that position!`);
    return jump(AfterClubSexTapeAgree3, "AfterClubSexTapeAgree3");
};
export const AfterClubSexTapeAgree3 = async (): Promise<any> => {
    ImageClass.setImage(images.v4.SexTape13);
    vanessa.talk(`Look who finally showed up for the party. Haha.`);
    ImageClass.setImage(images.v4.SexTape14);

    joe.talk(`Shut up.`);
    vanessa.talk(`AHH FUCK!`);
    if (Question.globalAnswers.todWatchedJoeVanessaFucking) {

        mc.think(`He is fucking her harder than the other day in my living room.`);
        mc.think(`I don't know if that's the excitement of me watching or he just wants to look good on camera.`);
    }
    ImageClass.setImage(images.v4.SexTape13);
    joe.talk(`Do you like it?`);
    vanessa.talk(`Fuck yes.`);
    ImageClass.setImage(images.v4.SexTape14);
    vanessa.talk(`AHHH!`);
    ImageClass.setImage(images.v4.SexTape13);
    vanessa.talk(`${mc.name}, are you getting thi...`);
    ImageClass.setImage(images.v4.SexTape14);
    vanessa.talk(`FUCK!`);
    ImageClass.setImage(images.v4.SexTape20);
    mc.think(`I can't lie, it really turned me on.`);
    ImageClass.setImage(images.v4.SexTape13);
    joe.talk(`Vanessa turn around.`);
    ImageClass.setImage(images.v4.SexTape15, { transition: true });
    vanessa.talk(`Take a closer shot, haven't you seen any porn?`);
    ImageClass.setImage(images.v4.SexTape16);
    if (Question.globalAnswers.v4TrickJoeyDrinkDrug) {

        mc.think(`What's that? I feel something touching my cock.`);
        mc.think(`I didn't realize I was so close to her face, not that I'm complaining.`);
        ImageClass.setImage(images.v4.SexTape17);
        mc.think(`Seeing her lying like that, helpless, licking my cock made me want to explode.`);
        mc.think(`Why is Joey cool with this?`);
        ImageClass.setImage(images.v4.SexTape19);

        mc.think(`Oh shit, the drug he took must have taken full effect, he is fucking Vanessa but I don't think he is aware of what's happening.`);
        mc.think(`I better keep quiet.`);
        ImageClass.setImage(images.v4.SexTape18);


        if (Question.globalAnswers.v3VanessaCoffeeWhatTryingToGain === "dontHurtJoey") {

            mc.think(`Fuck! I was waiting for this!`);
            mc.think(`I told her not to hurt Joey, but I didn't see him getting hurt.`);
            mc.think(`Besides, it was really hard to think straight while she was licking the tip of my cock.`);
        } else if (Question.globalAnswers.v3VanessaCoffeeWhatTryingToGain === "blackmailHer") {
            if (Question.globalAnswers.v3VanessaCoffeeJustSuckIt) {
                mc.think(`Fuck! I missed her mouth so much!`);
                mc.think(`It's so weird she was doing that after I tried to blackmail her earlier.`);
                mc.think(`I would never understand what's going on in her head...`);
                mc.think(`But at that moment, the only thing that I wanted in her head was my cock.`);
            } else if (Question.globalAnswers.v3VanessaCoffeeJustSuckIt === false) {

                mc.think(`Fuck! I was waiting for this!`);
                mc.think(`I really wanted this in the coffee shop earlier.`);
                mc.think(`It was worth the wait.`);
            } else {

                mc.think(`Fuck! I was waiting for this!`);
                mc.think(`I tried to blackmail her, but she wasn't playing along.`);
                mc.think(`But now she was sucking my dick.`);
                mc.think(`I would never understand what's going on in her head... `);
                mc.think(`But at that moment, the only thing that I wanted in her head was my cock.`);
            }
        }
        mc.think(`This feels good.`);
        mc.think(`Joey is wasted but Vanessa is fully aware of what's happening.`);
        mc.think(`She is spinning her tongue and putting pressure in the right spot, FUCK!`);
        ImageClass.setImage(images.v4.SexTape15);

        mc.think(`Oh no, why did she stop?`);
        vanessa.talk(`Joe let me get on top of you.`);
        vanessa.talk(`JOE!! Hello???`);
        joe.talk(`Oh yeah, yeah, right...`);

    } else {
        vanessa.talk(`Yes honey! Give it to me!`);
        ImageClass.setImage(images.v4.SexTape15);
        vanessa.talk(`Harder!`);
        mc.think(`Vanessa is a total slut but she knows how to give an innocent look to the camera.`);
        if (Question.globalAnswers.v3VanessaCoffeeLikedWatchingVanessaJoeFuck) {
            vanessa.talk(`I know you like watching us.`);
            vanessa.talk(`And I know we are putting a good show because your cock is still hard.`);
            ImageClass.setImage(images.v4.SexTape20);

            mc.think(`That's true...`);
            vanessa.talk(`Joe stop.\nLet me get on top of you.`);
        }
    }

    ImageClass.setImage(images.v4.SexTape21, { transition: true });
    //<action type="image" nb="true" add="true" animate="false" wi="false">"Game/V4/CamFrame"</action>
    vanessa.talk(`Do I look good in this position?`);
    mc.talk(`Yes.`);
    mc.think(`She is fucking Joe but the camera is all she cares about.`);
    ImageClass.setImage(images.v4.SexTape22);

    vanessa.talk(`Ah...`);
    ImageClass.setImage(images.v4.SexTape21);

    vanessa.talk(`Oh...`);
    vanessa.talk(`I am thirsty.`);
    mc.talk(`Way to ruin the mood!`);
    vanessa.talk(`A girl needs her drink.`);
    ImageClass.setImage(images.v4.SexTape23);

    vanessa.talk(`Can you give me my glass of wine?`);
    ImageClass.setImage(images.v4.SexTape24);

    vanessa.talk(`It's over there.`);
    mc.talk(`Sure.`);
    ImageClass.setImage(images.v4.SexTape25);

    mc.talk(`There you go.`);
    vanessa.talk(`Thanks.`);
    ImageClass.setImage(images.v4.SexTape26);

    mc.think(`She is casually drinking the wine while having Joey's cock halfway inside of her.`);
    joe.talk(`Babe, give it here, I've also been dying for a drink.`);

    return jump(AfterClubSexTapeAgree4, "AfterClubSexTapeAgree4");
};
export const AfterClubSexTapeAgree4 = async (): Promise<any> => {
    ImageClass.setImage(images.v4.SexTape26);


    if (Question.globalAnswers.v4TrickJoeyDrinkDrug) {
        await mc.setQuestion(new Question({ text: `Joey has been drinking a lot already, and with the mix of what Vanessa put in the drink he drank I don't know what might happen.`, options: { think: true }, key: `v4SexTapeMadeJoeyPassOut` })
            .option({ title: `Let him drink`, key: true })
            .option({ title: `Stop him`, key: false }));


        if (Question.globalAnswers.v4SexTapeMadeJoeyPassOut) {


            ImageClass.setImage(images.v4.SexTape27);

            vanessa.talk(`There you go honey.`);
            ImageClass.setImage(images.v4.SexTape21);
            //// <action type="image" nb="true" add="true" wi="true">"Game/V4/CamFrame"</action>
            vanessa.talk(`I'll just keep myself busy till you are done.`);
            ImageClass.setImage(images.v4.SexTape22, { wait: 1 });
            ImageClass.setImage(images.v4.SexTape21, { wait: 1 });
            ImageClass.setImage(images.v4.SexTape22, { wait: 1 });
            joe.talk(`Take it.`);
            ImageClass.setImage(images.v4.SexTape28);

            vanessa.talk(`So fast!`);
            joe.talk(`I was thirsty.`);
            ImageClass.setImage(images.v4.SexTape22);

            vanessa.talk(`Back to business!`);
            ImageClass.setImage(images.v4.SexTape21, { wait: 1 });
            ImageClass.setImage(images.v4.SexTape22, { wait: 1 });
            ImageClass.setImage(images.v4.SexTape29);
            vanessa.talk(`Joe?`);

            vanessa.talk(`JOE??`);
            mc.talk(`What happened?`);
            ImageClass.setImage(images.v4.SexTape30);

            vanessa.talk(`He stopped moving.`);
            vanessa.talk(`Put the camera down!`);
            ImageClass.setImage(images.v4.SexTape31);
            vanessa.talk(`JOE?`);
            vanessa.talk(`Heeelloooo?`);
            vanessa.talk(`Honey!`);
            return jump(AfterClubSexTapeAgree4JoePassedout, "AfterClubSexTapeAgree4JoePassedout");

        } else {

            ImageClass.setImage(images.v4.SexTape26);
            mc.talk(`Vanessa wait.`);
            mc.talk(`I think he's had too much to drink.`);
            joe.talk(`Nonnn...sense!`);
            ImageClass.setImage(images.v4.SexTape25);

            vanessa.talk(`You are right.`);
            vanessa.talk(`Take it.`);
            joe.talk(`Come on!`);

        }
    } else {

        ImageClass.setImage(images.v4.SexTape27);

        vanessa.talk(`There you go honey.`);
        ImageClass.setImage(images.v4.SexTape22);

        vanessa.talk(`I'll just keep myself busy till you are done.`);
        joe.talk(`Take it.`);

        ImageClass.setImage(images.v4.SexTape28);

        vanessa.talk(`Woah, so fast.`);
    }

    return jump(AfterClubSexTapeAgree4JoeDidntPassOut, "AfterClubSexTapeAgree4JoeDidntPassOut");


};
export const AfterClubSexTapeAgree4JoePassedout = async (): Promise<any> => {
    ImageClass.setImage(images.v4.SexTape31);

    await mc.setQuestion(new Question({ text: `Joe passed out but seeing Vanessa in this position is really turning me on.`, options: { think: true }, key: `v4SexTapeFuckedVanessa` })
        .option({ title: `Penetrate her`, key: true })
        .option({ title: `Check up on Joey`, key: false }));


    if (Question.globalAnswers.v4SexTapeFuckedVanessa) {

        mc.think(`Fuck it, I've been watching them for too long, now it's my turn.`);
        ImageClass.setImage(images.v4.SexTape32);
        vanessa.talk(`AHH!`);
        mc.think(`Finally, Vanessa's pussy is mine.`);
        mc.think(`She is so wet my dick slid right inside of her.`);
        mc.think(`I'd be stupid to record this.`);
        ImageClass.setImage(images.v4.SexTape33);
        vanessa.talk(`${mc.name}??? What are you doing?`);
        mc.talk(`It's my turn now.`);
        vanessa.talk(`But! Joe... He is...`);
        ImageClass.setImage(images.v4.Anim_SexTapeDoggy.poster);
        mc.talk(`Quiet, let me enjoy this.`);





        ImageClass.setAnimation(images.v4.Anim_SexTapeDoggy, { duration: 0 });
        mc.think(`She gave in to my cock.`);
        vanessa.talk(`Joe... Mnnnmm.`);
        vanessa.talk(`Ahhh... Fuck!`);
        vanessa.talk(`Wake up J... Uuuuaaa.`);
        mc.think(`She is enjoying it while worrying about Joey. Damn her ass is perfect.`);
        vanessa.talk(`Oh my GOD!`);
        mc.talk(`Ahhh!`);
        ImageClass.setAnimation(images.v4.Anim_SexTapeCum, { loop: 0, wait: 2.2 });
        ImageClass.setImage(images.v4.SexTape36);
        mc.think(`I was so horny and she felt so fantastic that it took me less than a minute to cum.`);
        ImageClass.setImage(images.v4.SexTape37);
        vanessa.talk(`Can we check up on Joe now?`);
        mc.talk(`Of course.`);
    }


    return jump(AfterClubSexTapeAgree4JoePassedout2, "AfterClubSexTapeAgree4JoePassedout2");
};
export const AfterClubSexTapeAgree4JoePassedout2 = async (): Promise<any> => {

    ImageClass.setImage(images.v4.SexTape31);
    vanessa.talk(`Joe?`);
    mc.talk(`Try slapping him.`);
    ImageClass.setImage(images.v4.SexTape39);
    empty.think(`Slap!`);
    ImageClass.setImage(images.v4.SexTape40);
    vanessa.talk(`It's not working.`);
    vanessa.talk(`We should call an ambulance.`);
    mc.talk(`I'm sure he will wake up in a minute.`);
    vanessa.talk(`How are you so calm??? Your friend might be dead for all you know.`);
    mc.talk(`Because I think it's my fault.`);
    vanessa.talk(`Your fault? What do you mean?`);
    mc.talk(`Remember the thing you put in Ann's drink earlier?`);
    vanessa.talk(`What about that?`);
    mc.talk(`Well, I tricked Joey to drink it.`);
    ImageClass.setImage(images.v4.SexTape41);
    vanessa.talk(`Oh!`);
    mc.talk(`Why are you smiling?`);
    vanessa.talk(`Because now I know he will be ok.`);
    mc.talk(`Can you finally tell me what it is?`);
    vanessa.talk(`Just something my friend gave me. I am not sure exactly what it is, but it makes people very horny.`);
    mc.talk(`Like Viagra?`);
    vanessa.talk(`More like hormones, since it works for both men and women.`);
    mc.talk(`I haven't seen Joey acting more different than usual to be honest.`);
    vanessa.talk(`That's because he is always horny. Haha.`);
    mc.talk(`Well, what do we do now?`);
    vanessa.talk(`We just wait.`);
    mc.talk(`Move, let me try something.`);
    ImageClass.setImage(images.v4.SexTape42);

    mc.talk(`Sorry about this Joey.`);
    ImageClass.setImage(images.v4.SexTape43, { shake: true });

    empty.think(`*SLAP!!!*`);
    vanessa.talk(`It worked!`);
    joe.talk(`Huh? What happened?`);

    ImageClass.setImage(images.v4.SexTape44);
    mc.talk(`You passed out.`);
    joe.talk(`Did I?`);
    joe.talk(`Weird, I don't remember drinking that much.`);
    joe.talk(`That has never happened to me before.`);
    joe.talk(`I'm sorry for ruining it for you babe.`);
    vanessa.talk(`You didn't honey, it was great.`);

    vanessa.talk(`Besides, it was for you, it's your present.`);
    joe.talk(`Yeah... I know.`);
    joe.talk(`I will make it up to you.`);

    ImageClass.setImage(images.v4.SexTape46);

    joe.talk(`Sorry for the drama ${mc.name}.`);
    mc.talk(`It's ok. I'm glad you are fine.`);
    mc.talk(`I'll get going now.`);
    vanessa.talk(`Bye ${mc.name}.`);
    joe.talk(`Bye dude.`);
    await endReplay(replayScenesList.v4Sextape);

    return jump(AfterClubEndDay, "AfterClubEndDay");
};
export const AfterClubSexTapeAgree4JoeDidntPassOut = async (): Promise<any> => {


    ImageClass.setImage(images.v4.SexTape21);
    mc.think(`Vanessa keeps riding Joey's dick while looking straight at the camera.`);
    ImageClass.setImage(images.v4.SexTape22);

    joe.talk(`Babe, I am close!`);
    ImageClass.setImage(images.v4.SexTape21);

    vanessa.talk(`Hold on, I didn't cum yet.`);
    ImageClass.setImage(images.v4.SexTape22);

    vanessa.talk(`Ah!`);
    ImageClass.setImage(images.v4.SexTape21);
    vanessa.talk(`Ah!`);
    ImageClass.setImage(images.v4.SexTape22);
    joe.talk(`Fuck.`);
    ImageClass.setImage(images.v4.SexTape48);

    vanessa.talk(`Joe! Wait!`);
    ImageClass.setImage(images.v4.SexTape49);

    joe.talk(`Ahhh!!!`);
    ImageClass.setImage(images.v4.SexTape50);
    vanessa.talk(`Shit.`);
    joe.talk(`What's wrong?`);
    vanessa.talk(`I wanted to end it with a facial!`);
    joe.talk(`Damn, why didn't you tell me? I couldn't control myself.`);
    ImageClass.setImage(images.v4.SexTape51);
    vanessa.talk(`I guess I have to work with what I've got.`);
    ImageClass.setImage(images.v4.SexTape52);

    vanessa.talk(`Mmm...`);
    mc.talk(`That's hot.`);
    joe.talk(`What's happening? I can't see.`);
    mc.talk(`You will see it later.`);
    ImageClass.setImage(images.v4.SexTape53, { transition: true });
    joe.talk(`That was great.`);
    vanessa.talk(`I know right!`);
    ImageClass.setImage(images.v4.SexTape54);
    joe.talk(`I hope you got everything on video ${mc.name}.`);
    mc.talk(`I did.`);
    joe.talk(`Thanks again for doing it.`);
    joe.talk(`I will do the same for you if you ask me.`);
    mc.talk(`You owe me one!`);
    joe.talk(`I sure do, haha.`);
    if (mc.properties.annLateGF) {
        mc.talk(`Well, I'll get going, Ann is waiting for me.`);
        ImageClass.setImage(images.v4.SexTape54);

        vanessa.talk(`Is she at your place???`);
        mc.talk(`Yes.`);
        ImageClass.setImage(images.v4.SexTape55);
        vanessa.talk(`Did you fuck?`);
        ImageClass.setImage(images.v4.SexTape54);
        mc.talk(`Not yet.`);
        vanessa.talk(`I need to put a GPS in her pussy so you can find the way.`);
        mc.talk(`Relax, we are getting there.`);
        ImageClass.setImage(images.v4.SexTape53);
        joe.talk(`Give them their time honey.`);
        vanessa.talk(`I can't! I want her to get laid already.`);
    } else {
        mc.talk(`Well, I'll get going it's been a long day.`);
        vanessa.talk(`Wait.`);
        vanessa.talk(`How did you have the time to come here anyway?`);
        ImageClass.setImage(images.v4.SexTape55);
        vanessa.talk(`Didn't you take Ann home?`);
        mc.talk(`I didn't.`);
        ImageClass.setImage(images.v4.SexTape54);
        vanessa.talk(`Why not?`);
        mc.talk(`It's a long story, I'll tell you some other time.`);
    }


    mc.talk(`Anyway, bye guys.`);
    joe.talk(`Bye, ${mc.name}.`);
    await endReplay(replayScenesList.v4Sextape);


    return jump(AfterClubEndDay, "AfterClubEndDay");
};
export const AfterClubSexTapeRefused = async (): Promise<any> => {
    await endReplay();

    return jump(AfterClubEndDay, "AfterClubEndDay");
};


